import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {AuthenticationGuard} from '../shared/authentication';

import {ProcessReplyEmailComponent} from './process-reply-email.component';

const routes: Routes = [
  {
    path: 'process-reply-email',
    canActivate: [AuthenticationGuard],
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: 'tasks',
        canActivate: [AuthenticationGuard],
        runGuardsAndResolvers: 'always',
        children: [
          {
            path: ':taskId',
            canActivate: [AuthenticationGuard],
            runGuardsAndResolvers: 'always',
            children: [
              {
                path: 'complete',
                component: ProcessReplyEmailComponent,
                canActivate: [AuthenticationGuard],
                runGuardsAndResolvers: 'always'
              }
            ]
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class ProcessReplyEmailRoutesModule {
}
